import { useCallback, useEffect, useState, useRef } from 'react'
import { Button, Select, Space, Card, Row, Col, Typography, Tag, Pagination, Input } from 'antd';
import { EyeOutlined, EditOutlined, TeamOutlined, PercentageOutlined } from '@ant-design/icons';
import {
    apiGetListPackageDataSponsor,
} from "../../api";
import { useLoading } from '../../context/LoadingContext';
import { formatCurrency } from '../../utils/string-utils';
import { Link } from 'react-router-dom';
import { CREATE_PACKAGES_SPONSOR, EDIT_PACKAGES_SPONSOR, PACKAGES } from '../../assets/constants/route_path';
import ViewPackagesSponsor from './ViewPackagesSponsor';
import { formatDate } from '../../utils/entity-utils';
import {
    partnerPackageDataSponsorSourceOptions,
    providerDisplayOptions,
    packageTypeOptions,
} from '../../assets/constants/default_option';
import defaultParams from '../../assets/constants/default_params';
import {
    mapProviderDisplay,
    mapSourcePackageDataSponsor,
    VIETTEL_TT,
} from "../../assets/constants/constants";

const { Title, Text } = Typography;

export default function TabPackagesSponsor() {
    const [sponsors, setSponsors] = useState<any>({})
    const [source, setSource] = useState('')
    const [scope, setScope] = useState('')
    const [type, setType] = useState('')
    const [debouncedType, setDebouncedType] = useState('')
    const [provider, setProvider] = useState('')
    const [searchDataPack, setSearchDataPack] = useState('')
    const [debouncedSearchDataPack, setDebouncedSearchDataPack] = useState('')
    const [currentPage, setCurrentPage] = useState(defaultParams.PAGE)
    const [pageSize, setPageSize] = useState(defaultParams.LIMIT)
    const [modalView, setModalView] = useState<{ data: any, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })

    const { setIsLoading } = useLoading()

    // Create custom debounced search function
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null)
    const debounceTypeTimerRef = useRef<NodeJS.Timeout | null>(null)

    const debouncedSearch = useCallback((value: string) => {
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current)
        }
        debounceTimerRef.current = setTimeout(() => {
            setDebouncedSearchDataPack(value)
            setCurrentPage(1)
        }, 500)
    }, [])

    const debouncedTypeSearch = useCallback((value: string) => {
        if (debounceTypeTimerRef.current) {
            clearTimeout(debounceTypeTimerRef.current)
        }
        debounceTypeTimerRef.current = setTimeout(() => {
            setDebouncedType(value)
            setCurrentPage(1)
        }, 500)
    }, [])

    const fetchDataSponsor = useCallback(async () => {
        try {
            setIsLoading(true)
            // Build query params for backend filtering
            const params: any = {
                page: currentPage,
                size: pageSize,
            }

            // Add optional filters if they have values
            if (debouncedSearchDataPack) {
                params.dataPack = debouncedSearchDataPack
            }
            if (source) {
                params.source = source
            }
            if (debouncedType) {
                params.type = debouncedType
            }

            const resSponsors = await apiGetListPackageDataSponsor(params)
            if (resSponsors.data != null) {
                const listSponsors = resSponsors.data.packages.map((item: any) => ({
                    ...item.package,
                    metadata: item.metadataPackages || [],
                }));
                setSponsors({packages: listSponsors, total: resSponsors.data.total || listSponsors.length})
            } else {
                setSponsors({packages: [], total: 0})
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }, [currentPage, pageSize, debouncedSearchDataPack, source, debouncedType, setIsLoading])

    useEffect(() => {
        fetchDataSponsor()
    }, [fetchDataSponsor])

    const renderSponsorCard = (sponsor: any, index: number) => (
        <Card
            key={sponsor.ID || index}
            style={{
                marginBottom: 16,
                border: '1px solid #f0f0f0',
                borderRadius: 8
            }}
        >
            <Row justify="space-between" align="top">
                <Col span={24}>
                    <div style={{ marginBottom: 12 }}>
                        <Row justify="space-between" align="middle">
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: '50%',
                                        backgroundColor: '#52c41a',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                            {sponsor.name}
                                        </Title>
                                        <Text type="secondary">
                                            {sponsor.dataPack}
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Row gutter={24} style={{ marginBottom: 16 }}>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>GIÁ</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {formatCurrency(sponsor.priceUnit)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PHẠM VI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {sponsor.scope}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>LOẠI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {sponsor.type}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>NGUỒN</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {mapSourcePackageDataSponsor[sponsor.source]}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRẠNG THÁI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Tag color="green" style={{ fontSize: '11px' }}>
                                        {sponsor.status}
                                    </Tag>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>NHÀ CUNG CẤP</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {
                                          Array.from(new Set(
                                            sponsor?.metadata?.map((item: any) =>
                                              (item.provider && mapProviderDisplay[item.provider]) || item.provider
                                            ) || []
                                          )).join(", ")
                                          || (
                                            ['DataSponsor', 'Affapi'].includes(sponsor?.source) ? VIETTEL_TT : ''
                                          )
                                        }
                                    </Text>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 12,
                        padding: '12px',
                        backgroundColor: '#fafafa',
                        borderRadius: 6,
                        border: '1px solid #f0f0f0'
                    }}>
                        <div>
                            <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>THỜI GIAN TẠO</Text>
                            <div style={{ marginTop: 4 }}>
                                <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                    {sponsor.CreatedAt ? formatDate(sponsor.CreatedAt) : ''}
                                </Text>
                            </div>
                        </div>
                        <Space>
                            <Button
                                onClick={() => setModalView({ data: sponsor, isOpen: true })}
                                style={{ color: 'white', background: 'gray' }}
                                icon={<EyeOutlined />}
                            >
                            </Button>
                            <Link to={PACKAGES + EDIT_PACKAGES_SPONSOR + `?id=${sponsor.ID}`}>
                                <Button
                                    style={{ color: 'white', background: 'orange' }}
                                    icon={<EditOutlined />}
                                >
                                </Button>
                            </Link>
                        </Space>
                    </div>
                </Col>
            </Row>
        </Card>
    )

    // Frontend filtering
    let filteredPackages = sponsors?.packages || []

    // Filter by scope
    if (scope) {
        filteredPackages = filteredPackages.filter((pkg: any) => pkg.scope === scope)
    }

    // Filter by provider (check in metadata array)
    if (provider) {
        filteredPackages = filteredPackages.filter((pkg: any) =>
            pkg.metadata?.some((meta: any) => {
                if (provider === 'viettel_tt') {
                    return meta.provider === 'data_sponsor' || meta.provider === 'ds_postpaid'
                }
                return meta.provider === provider
            })
        )
    }

    // Backend handles pagination, so use filtered packages directly
    const sponsorPackages = filteredPackages
    const totalRecords = scope || provider ? filteredPackages.length : (sponsors?.total || 0)

    const allPackages = sponsors?.packages || []
    const totalPackages = allPackages.length
    const activePackages = allPackages.filter((pkg: any) => pkg.status === 'Active').length
    const avgPrice = totalPackages > 0 ? (allPackages.reduce((acc: number, pkg: any) => acc + (pkg.priceUnit || 0), 0) / totalPackages) : 0

    return (
        <>
            {/* Statistics Header */}
            <Row gutter={24} style={{ marginBottom: 24 }}>
                <Col span={6}>
                    <Card>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 8,
                                backgroundColor: '#e6f7ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <TeamOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                            </div>
                            <div>
                                <Text type="secondary">Tổng gói</Text>
                                <div>
                                    <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                        {totalPackages}
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 8,
                                backgroundColor: '#f6ffed',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <TeamOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                            </div>
                            <div>
                                <Text type="secondary">Gói đang hoạt động</Text>
                                <div>
                                    <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                        {activePackages}
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 8,
                                backgroundColor: '#fff7e6',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <PercentageOutlined style={{ color: '#fa8c16', fontSize: '20px' }} />
                            </div>
                            <div>
                                <Text type="secondary">Giá trung bình</Text>
                                <div>
                                    <Title level={3} style={{ margin: 0, color: '#fa8c16' }}>
                                        {avgPrice > 0 ? formatCurrency(avgPrice) : '0'}
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={4}>
                    <div>
                        <Text strong>Chọn nguồn</Text>
                        <Select
                            style={{ width: '100%', marginTop: 4 }}
                            placeholder="Chọn nguồn"
                            value={source}
                            onChange={(value) => {
                                setSource(value || '')
                                setCurrentPage(1)
                            }}
                            options={[
                                { label: 'Tất cả', value: '' },
                                ...partnerPackageDataSponsorSourceOptions,
                            ]}
                        />
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Text strong>Chọn loại</Text>
                        <Select
                            style={{ width: '100%', marginTop: 4 }}
                            placeholder="Chọn hoặc nhập loại"
                            value={type || undefined}
                            onChange={(value) => {
                                const newValue = value || ''
                                setType(newValue)
                                debouncedTypeSearch(newValue)
                            }}
                            showSearch
                            allowClear
                            options={packageTypeOptions}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            onSearch={(value) => {
                                // Allow typing custom values
                                setType(value)
                                debouncedTypeSearch(value)
                            }}
                            notFoundContent={
                                <div style={{ padding: '8px', cursor: 'pointer' }}>
                                    Nhập để tìm kiếm hoặc thêm giá trị mới
                                </div>
                            }
                        />
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Text strong>Chọn nhà cung cấp</Text>
                        <Select
                            style={{ width: '100%', marginTop: 4 }}
                            placeholder="Chọn nhà cung cấp"
                            value={provider}
                            onChange={(value) => {
                                setProvider(value || '')
                                setCurrentPage(1)
                            }}
                            options={[
                                { label: 'Tất cả', value: '' },
                                ...providerDisplayOptions
                            ]}
                        />
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Text strong>Chọn phạm vi</Text>
                        <Select
                          style={{ width: '100%', marginTop: 4 }}
                          placeholder="Chọn phạm vi"
                          value={scope}
                          onChange={(value) => {
                              setScope(value || '')
                              setCurrentPage(1)
                          }}
                          options={[
                              { label: 'Tất cả', value: '' },
                              ...Array.from(new Set((sponsors?.packages || []).map((pkg: any) => pkg.scope).filter(Boolean)))
                                .map((s: any) => ({ label: s, value: s }))
                          ]}
                        />
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Text strong>Tìm kiếm mã gói</Text>
                        <Input
                            style={{ marginTop: 4 }}
                            placeholder="Nhập mã gói cước"
                            value={searchDataPack}
                            onChange={(e) => {
                                const value = e.target.value
                                setSearchDataPack(value)
                                debouncedSearch(value)
                            }}
                            allowClear
                        />
                    </div>
                </Col>
                <Col span={4}>
                    <div style={{ marginTop: 24, textAlign: 'right' }}>
                        <Link to={PACKAGES + CREATE_PACKAGES_SPONSOR}>
                            <Button type="primary">
                                Thêm gói cước
                            </Button>
                        </Link>
                    </div>
                </Col>
            </Row>

            {sponsorPackages.length > 0 ? (
                <div>
                    {sponsorPackages.map((sponsor: any, index: number) => renderSponsorCard(sponsor, index))}
                </div>
            ) : (
                <Card>
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                        <Title level={4} type="secondary">
                            No Data Sponsor Packages Found
                        </Title>
                        <Text type="secondary">
                            Configure data sponsor packages
                        </Text>
                    </div>
                </Card>
            )}

            {/* Pagination */}
            {totalRecords > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 24 }}>
                    <div>
                        <Text>Tổng {totalRecords} gói cước</Text>
                    </div>
                    <Pagination
                        showSizeChanger
                        pageSizeOptions={['10', '20', '50', '100', '200']}
                        pageSize={pageSize}
                        onShowSizeChange={(_current, size) => {
                            setPageSize(size)
                            setCurrentPage(1)
                        }}
                        total={totalRecords}
                        current={currentPage}
                        onChange={page => {
                            setCurrentPage(page)
                            window.scroll({top: 0, behavior: 'smooth'})
                        }}
                    />
                </div>
            )}

            <ViewPackagesSponsor
                modalView={modalView}
                setModalView={setModalView}
            />
        </>
    )
}
